<template>
  <div>
    <div class="Rectangle-11" v-bind:style="{ height: +windowHeight + 'px' }">
      <!-- <img class="Rectangle-11-img" style="margin-top:7%" src="../assets/logo.png" /> -->
      <div style="margin-top: 7%">
        <div class="Rectangle-12" style="margin-top: 50px">
          <div
            class="Rectangle-12-text"
            style="font-weight: bold; margin-top: 10%"
          >
            <!-- <img style="width:100px;height:44px;vertical-align:bottom;display:inline-block" src="../assets/Group 1@3x.png" /> -->
            <div
              style="
                vertical-align: bottom;
                display: inline-block;
                margin-left: 10px;
                margin-top: 10px;
              "
            >
              后台登录
            </div>
          </div>
          <el-input
            style="padding: 20px; width: 80%; margin-top: 5%"
            v-model="inputUsername"
            placeholder="Email"
          ></el-input>
          <el-input
            type="password"
            style="padding: 20px; width: 80%; padding-top: 0px"
            v-model="inputPassword"
            placeholder="Enter the password"
          ></el-input>
          <el-button
            @click="onLogin()"
            style="
              width: 80%;
              background-color: #1bb24b;
              color: #fff;
              margin-top: 20px;
            "
            >登入</el-button
          >
        </div>
      </div>

      <div>
        <div class="Rectangle-13" style="margin-top: 5%">
          <!-- <div>© Copyright 2008 - 2019 Area. All rights reserved.</div> -->
          <div>
            Powered by
            <div style="font-weight: bold; display: inline-block">Bleve</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  props: {
    msg: String,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      inputUsername: "",
      inputPassword: "",
    };
  },
  created() {
    this.onCheckloginRole();
  },
  methods: {
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != 'b60afdc1f3657130c165d32743603a59') {
      //   this.$router.push("/login");
      //   return;
      // } else {
      //   this.$router.push("/userList");
      // }
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
          } else {
            this.$router.push("/userList");
          }
        });
    },

    onLogin() {
      if (this.inputUsername == "" || this.inputPassword == "") {
        this.$message({
          showClose: true,
          message: "账号密码不能为空",
          type: "warning",
        });
        return;
      }

      var tempPassword = this.inputPassword;
      tempPassword = this.$md5(this.inputPassword);

      this.axios
        .post(this.$urlGlobal + "adminLogin", {
          username: this.inputUsername,
          password: tempPassword,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.code == "0") {
            localStorage.setItem("auth", res.data.data.auth);
            window.location.reload();
          } else {
            this.$message({
              showClose: true,
              message: "账号密码错误",
              type: "warning",
            });
          }
        });
    },
  },
};
</script>

<style >
.Rectangle-11 {
  width: 100%;
  display: inline-block;
  text-align: center;
  background-size: 100% 100%;
  background-color: white;
}
.Rectangle-11-img {
  width: 383px;
  height: 72px;
}
.Rectangle-12 {
  width: 420px;
  height: 358px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
  border-radius: 19px;
  border-radius: 19px;
  display: inline-block;
}
.Rectangle-12-text {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #000000;
  letter-spacing: 0.71px;
  text-align: center;
}
.Rectangle-13 {
  font-family: BwModelica-Regular;
  font-size: 10px;
  color: #2f8ccb;
  letter-spacing: 0.36px;
  text-align: center;
  display: inline-block;
}
</style>>
